import React from "react";
import i18n from "i18next";
import PdfFileItem from "@/react-components/PdfFileItem";
import { libraryTypeEnum } from "@/utils/enum";

class LibraryPdfItem extends React.Component {
  render() {
    const { item, classFlex } = this.props;
    let updFlg =
      item.updateDate &&
      new Date(item.updateDate?.slice(0, 10)) >
        new Date(item.createDate?.slice(0, 10));
    return (
      <div className={classFlex || "library-info-area"}>
        <div className="library-info-area-wrap">
          <div className="library-row-area">
            <div className="pdf-icon"></div>
            <PdfFileItem
              pdfFile={item.pdfFile}
              pdfTitle={item.title}
              itemId={item.id}
              libraryType={libraryTypeEnum.pdf}
            />
          </div>
          <div className="library-row-area">
            <div className={`${updFlg ? "update-icon" : "publish-icon"}`}></div>
            <span className="span-padding-left">{`${
              updFlg
                ? i18n.t("Library_kbn_update")
                : i18n.t("Library_kbn_publish")
            }：`}</span>
            <span>
              {item.updateDate
                ? item.updateDate?.slice(0, 10)?.replace(/-/g, ".")
                : item.createDate?.slice(0, 10)?.replace(/-/g, ".")}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default LibraryPdfItem;
